(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Brand', Brand);

  Brand.$inject = ['$resource', 'API_URI'];

  function Brand($resource, API_URI) {
    var resourceUrl = API_URI + 'api/brands/:id';

    return $resource(resourceUrl, {}, {
      'query': {
        method: 'GET',
        cache: true,
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'get': {
        method: 'GET',
        cache: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'},
      'save': {method: 'POST'}
    });
  }
})();
